import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';

export type MeanPressureConfigJson = {
  computationWindowSize: number;
};

export class MeanPressureComputationConfig implements JsonConfigInterface<MeanPressureConfigJson> {

  private _computationWindowSize: number = 0;

  constructor(json?: MeanPressureConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get computationWindowSize(): number {
    return this._computationWindowSize;
  }

  public deserializeJson(json: MeanPressureConfigJson): void {
    this._computationWindowSize = json.computationWindowSize;
  }
}
